var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import i18next from "i18next";
import { UrlHelper, date, logger } from "../helpers";
import { LanguageHelper } from "../helpers/language.helper";
var BaseConfigProvider = /** @class */ (function () {
    function BaseConfigProvider(data) {
        this.data = data;
        BaseConfigProvider.sentryEnvironment = data.sentryEnvironment;
        logger.log("BaseConfigProvider", data);
    }
    BaseConfigProvider.prototype.getLanguage = function () {
        return this.language;
    };
    BaseConfigProvider.prototype.getPaymentQRUrl = function () {
        return this.data.paymentQRUrl;
    };
    BaseConfigProvider.prototype.setLanguage = function (language) {
        this.language = language;
    };
    BaseConfigProvider.prototype.getIdentityHash = function () {
        return this.data.identityHash;
    };
    BaseConfigProvider.prototype.getSentryUrl = function () {
        return this.data.sentryUrl;
    };
    BaseConfigProvider.prototype.getSentryEnvironment = function () {
        return this.data.sentryEnvironment;
    };
    BaseConfigProvider.prototype.getFinapikUrl = function () {
        return this.data.fintechApiKUrl;
    };
    BaseConfigProvider.prototype.getProject = function () {
        return this.data.project;
    };
    BaseConfigProvider.prototype.getGitTag = function () {
        return this.data.gitTag;
    };
    BaseConfigProvider.prototype.getLogin = function () {
        return this.data.login;
    };
    BaseConfigProvider.prototype.isLoggedIn = function () {
        return this.getLogin() != null;
    };
    BaseConfigProvider.prototype.getExpiresIn = function () {
        if (this.isLoggedIn()) {
            var login = this.getLogin();
            if (login) {
                var expiresAt = login.accessToken.expires_at;
                if (typeof expiresAt === "string")
                    return date(login.accessToken.expires_at).diff(date(), "seconds");
                return date(login.accessToken.expires_at * 1000).diff(date(), "seconds");
            }
        }
        return 0;
    };
    BaseConfigProvider.prototype.isExpiredToken = function () {
        if (this.isLoggedIn()) {
            var login = this.getLogin();
            if (login) {
                return this.getExpiresIn() < 30;
            }
        }
        return true;
    };
    return BaseConfigProvider;
}());
export { BaseConfigProvider };
var ResourceConfigProvider = /** @class */ (function (_super) {
    __extends(ResourceConfigProvider, _super);
    function ResourceConfigProvider(data) {
        var _this = this;
        i18next.changeLanguage(LanguageHelper.detectLanguage(i18next.options.supportedLngs, i18next.options.fallbackLng[0].toString(), data.language));
        UrlHelper.changeUrlParam("language", i18next.language);
        _this = _super.call(this, data) || this;
        _this.data = data;
        _this.setLanguage(i18next.language);
        return _this;
    }
    ResourceConfigProvider.prototype.getCompanyId = function () {
        return this.data.companyId;
    };
    ResourceConfigProvider.prototype.getEmail = function () {
        return this.data.email;
    };
    ResourceConfigProvider.prototype.getInstalledAt = function () {
        return this.data.installed_at || date().subtract(1, "hour").unix();
    };
    ResourceConfigProvider.prototype.getFintechUrl = function () {
        return this.data.fintechUrl;
    };
    ResourceConfigProvider.prototype.getForgotUrl = function () {
        return this.data.ssoUrl;
    };
    ResourceConfigProvider.prototype.getBaseUrl = function () {
        return this.data.baseUrl;
    };
    ResourceConfigProvider.prototype.getAuthSegments = function () {
        return this.data.authUrl;
    };
    ResourceConfigProvider.prototype.getStateExpiresAt = function () {
        return this.data.stateExpiresAt;
    };
    ResourceConfigProvider.prototype.getPaymentQRUrl = function () {
        return this.data.paymentQRUrl;
    };
    ResourceConfigProvider.prototype.shouldReinstall = function () {
        return this.data.reinstall === true;
    };
    return ResourceConfigProvider;
}(BaseConfigProvider));
export { ResourceConfigProvider };
//# sourceMappingURL=base.config.provider.js.map